import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Button, Input, Row, Col } from 'reactstrap';
import * as actions from '../../../actions';
import { getTranslationKey } from '../../../modules/utils/helpers';
import type { Notify } from '../../../typings/redux';
import type { Watermark } from './types';

interface AvailableRules {
  canCreateCustomWatermark?: boolean;
}

interface NewWatermarkProps {
  onWatermarkCreated?: (watermark: Watermark) => void;
  createWatermark: (
    data: { description: string; type: string; text?: string },
    notify: Notify
  ) => Promise<Watermark>;
  notify: Notify;
  setUpgradeAccountOpenState: (data: any) => void;
  availableRules?: AvailableRules;
  children?: React.ReactNode;
}

interface NewWatermarkState {
  isOpen: boolean;
  description: string;
}

class NewWatermark extends Component<NewWatermarkProps, NewWatermarkState> {
  constructor(props: NewWatermarkProps) {
    super(props);

    this.state = {
      isOpen: false,
      description: ''
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { availableRules = {}, setUpgradeAccountOpenState } = this.props;
    const isLimitExcceeded = !availableRules.canCreateCustomWatermark;

    const toggleOpen = () => this.setState((prevState) => ({ isOpen: !prevState.isOpen }));

    if (isLimitExcceeded) {
      return setUpgradeAccountOpenState({
        key: 'upgradeModal',
        state: true,
        callback: toggleOpen,
        desiredAction: 'customWatermark'
      });
    }

    toggleOpen();
  }

  async create(type: 'text' | 'image') {
    const { createWatermark, notify, onWatermarkCreated } = this.props;
    const watermark = await createWatermark(
      {
        description: this.state.description || getTranslationKey('watermark.defaultDescription'),
        type,
        text: type === 'text' ? getTranslationKey('watermark.defaultText') : undefined
      },
      notify
    );

    if (watermark && onWatermarkCreated) {
      this.setState({ isOpen: false, description: '' }, () => onWatermarkCreated(watermark));
    }
  }

  render() {
    const { availableRules = {} } = this.props;
    const { isOpen, description } = this.state;

    return (
      <div className="inline">
        <div onClick={this.toggle}>{this.props.children}</div>
        <Modal
          centered
          isOpen={isOpen && !!availableRules.canCreateCustomWatermark}
          toggle={this.toggle}
          wrapClassName="modal-dark"
          size="lg"
          backdrop
        >
          <ModalHeader toggle={this.toggle}>{getTranslationKey('watermark.add')}</ModalHeader>
          <ModalBody>
            <Row className="justify-content-center hidden">
              <Col xs="6">
                <small>
                  <b>{getTranslationKey('watermark.description')}</b>
                </small>
                <Input
                  className="mb-2"
                  value={description}
                  type="text"
                  onChange={({ target: { value } }) => this.setState({ description: value })}
                  placeholder={getTranslationKey('watermark.descriptionPlaceholder')}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" sm="12">
                <Button
                  onClick={() => this.create('image')}
                  color="primary"
                  className="mb-2 w-100-p"
                >
                  {getTranslationKey('watermark.imageWatermark')}
                </Button>
                <h5>{getTranslationKey('example')}:</h5>
                <img
                  className="img-fluid mb-2"
                  src={`${window.CDN_URL}/public/previewWatermarkImage.jpg`}
                  alt=""
                />
              </Col>

              <Col md="6" sm="12">
                <Button
                  onClick={() => this.create('text')}
                  color="primary"
                  className="w-100-p mb-2"
                >
                  {getTranslationKey('watermark.textWatermark')}
                </Button>
                <h5>{getTranslationKey('example')}:</h5>
                <img
                  className="img-fluid mb-2"
                  src={`${window.CDN_URL}/public/previewWatermarkText.jpg`}
                  alt=""
                />
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

interface StateProps {
  notify: Notify;
  accessRules: {
    availableRules: AvailableRules;
  };
}

function mapStateToProps({ notify, accessRules: { availableRules } }: StateProps) {
  return { notify, availableRules };
}
export default connect(mapStateToProps, actions)(NewWatermark);
